import React, { useState, useEffect } from 'react';
import { Shield, Heart, Users, Clock, CheckCircle2, Phone, Mail, Calendar, TrendingUp, Award, Lock } from 'lucide-react';
import HeroSection from '../components/HeroSection';
import TrustBar from '../components/TrustBar';
import WhySection from '../components/WhySection';
import CostsSection from '../components/CostsSection';
import ExampleCalculationSection from '../components/ExampleCalculationSection';
import BenefitsSection from '../components/BenefitsSection';
import ProcessSection from '../components/ProcessSection';
import NewTestimonialsSection from '../components/NewTestimonialsSection';
import NewFAQSection from '../components/NewFAQSection';
import FinalCTA from '../components/FinalCTA';
import Header from '../components/Header';

const LandingPage = () => {
  const [showStickyCTA, setShowStickyCTA] = useState(false);
  const [calculatorRef, setCalculatorRef] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowStickyCTA(true);
      } else {
        setShowStickyCTA(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleOpenCalculator = () => {
    // Scroll to costs section
    const costsSection = document.querySelector('.costs-section');
    if (costsSection) {
      costsSection.scrollIntoView({ behavior: 'smooth' });
    }
    // Trigger calculator open after scroll
    setTimeout(() => {
      if (calculatorRef) {
        calculatorRef();
      }
    }, 500);
  };

  return (
    <div className="sterbegeld-landing">
      <Header showStickyCTA={showStickyCTA} onOpenCalculator={handleOpenCalculator} />
      <HeroSection />
      <TrustBar />
      <CostsSection onSetCalculatorRef={setCalculatorRef} />
      <ExampleCalculationSection />
      <WhySection />
      <BenefitsSection />
      <ProcessSection />
      <NewTestimonialsSection />
      <NewFAQSection />
      <FinalCTA />
    </div>
  );
};

export default LandingPage;

